export const BASE_SERIES_OPTIONS = {
    type: 'bar',
    avoidLabelOverlap: true,
    barGap: '50%',
    barMaxWidth: 60,
    tooltip: {
        position: 'top',
    },
};
